<template>
	<li>
		@{{user.username}}
		<span>
			<a @click="deleteSelected(user)">
				<ion-icon name="ios-close"></ion-icon>
			</a>
		</span>
	</li>
</template>

<script>
export default {
	props: {
		user: {
			type: Object
		}
	},
	methods: {
		deleteSelected(user) {
			this.$emit("userRemoved", user);
		}
	}
};
</script>

<style scoped>
li {
	color: #51c715;
	font-size: 12px;
	font-weight: bold;
	padding: 1px 7px 3px;
	margin-right: 5px;
	margin-bottom: 5px;
	border: 2px solid #51c715;
	border-radius: 20px;
}

ion-icon {
	color: #51c715;
	font-size: 17px;
	vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsSearch/GroupsSelectedUsers.vue